import * as yup from 'yup';

const ForgotPasswordSchema = yup.object().shape({
    password: yup.string()
        .required('Required'),
    confirmPassword: yup.string()
        .required('Required')
        .oneOf([yup.ref('password'), null], "Passwords don't match")
});

export default ForgotPasswordSchema;